//Actions
export const LOGIN_TOKEN = "SET_MYLOC_LOGIN_TOKEN";
export const REMEMBER_ME = "REMEMBER_ME";
export const AUTHORIZATION_LIST = "AUTHORIZATION_LIST";
export const USER_HAS_MESSAGE_TO_ACCPEPT = "USER_HAS_MESSAGE_TO_ACCPEPT";
